import { FC } from 'react';

export type StatusType = 'COMPLETED' | 'FAILED' | 'IN_PROGRESS';

interface StatusConfig {
	backgroundColor: string;
	text: string;
}

interface StatusBadgeProps {
	status: StatusType;
	date?: string;
	text?: string;
	prefixText?: string;
	className?: string;
}

const StatusBadge: FC<StatusBadgeProps> = ({
	status,
	date,
	text,
	prefixText = '',
	className = '',
}) => {
	const STATUS: Record<StatusType, StatusConfig> = {
		COMPLETED: {
			backgroundColor: '#34C38F',
			text: text ?? 'COMPLETED',
		},
		FAILED: {
			backgroundColor: '#F46A6A',
			text: text ?? 'FAILED',
		},
		IN_PROGRESS: {
			backgroundColor: '#078CB3',
			text: text ?? 'IN PROGRESS',
		},
	};

	const STATUS_DEFAULT: StatusConfig = {
		backgroundColor: '#6c757d',
		text: text ?? 'UNKNOWN',
	};

	const config = STATUS[status] ?? STATUS_DEFAULT;

	return (
		<div className={`flex flex-col ${className}`}>
			<div className="flex items-center gap-2">
				<div 
					className="w-2.5 h-2.5 rounded-full flex-shrink-0" 
					style={{ 
						backgroundColor: config.backgroundColor,
						marginTop: '1px'
					}} 
				/>
				<span className="text-sm font-medium text-gray-700">
					{prefixText} {config.text}
				</span>
			</div>
			{date && <div className="text-xs font-medium text-[#74788D] ">{date}</div>}
		</div>
	);
};

export default StatusBadge;
